import React from "react";
import Popover from "../popover";

const Tooltip = ({
  children,
  content = "",
  placement = "top",
  hideArrow = false,
  className = "",
  autoWidth = false,
  ...props
}) => {
  return (
    <Popover
      {...props}
      content={content}
      placement={placement}
      hideArrow={hideArrow}
      showOnHover={true}
      theme="black"
      className={`bimmatch-tooltip ${autoWidth ? "auto-width" : ""} ${className}`}
    >
      {children}
    </Popover>
  );
};

export default Tooltip;
